import Component from '../core/Component'
import { swup } from '../core/swup'
import { wecho } from '../core/swup'

export default class Accord extends Component {

    constructor(element) {
        super(element);
    }

    prepare() {
        this.ref.head.forEach(item => {
            item.addEventListener('click', () => {
                if (item.parentNode.classList.contains('is-active')) {
                    item.parentNode.classList.remove('is-active');
                } else {
                    this.ref.item.forEach(i => i.classList.remove('is-active'));
                    item.parentNode.classList.add('is-active');
                    //wecho.play('pop')

                    setTimeout(() => {
                        swup.scrollTo(window, window.pageXOffset !== undefined ? item.getBoundingClientRect().top + window.pageYOffset : item.getBoundingClientRect().top + document.documentElement.scrollTop)
                    }, 600)
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./components/Accord.js